(() => {
  const pickerSelector = 'variant-selects[data-product-form-id]';
  const readyProductInfo = new WeakSet();

  const activatePicker = (picker) => {
    if (picker.dataset.variantEnhanced === 'true') return;

    const productInfo = picker.closest('product-info');
    if (!productInfo || !readyProductInfo.has(productInfo)) return;

    const form = document.getElementById(picker.dataset.productFormId);
    if (!(form instanceof HTMLFormElement)) return;

    const nativeControl = form.querySelector('select[data-native-variant-control]');
    const enhancedControl = form.querySelector('input[data-js-variant-id]');
    if (!(nativeControl instanceof HTMLSelectElement) || !(enhancedControl instanceof HTMLInputElement)) return;
    if (nativeControl.dataset.variantPickerId !== picker.id) return;

    nativeControl.disabled = true;
    nativeControl.removeAttribute('name');
    enhancedControl.name = 'id';
    enhancedControl.disabled = enhancedControl.dataset.jsSubmitEnabled !== 'true';
    nativeControl.closest('[data-native-variant-wrapper]')?.setAttribute('hidden', '');

    const submitButton = form.querySelector('button[type="submit"][name="add"]');
    if (submitButton instanceof HTMLButtonElement) {
      submitButton.disabled = enhancedControl.dataset.jsSubmitEnabled !== 'true';
      const submitText = submitButton.querySelector('span');
      if (submitText && enhancedControl.dataset.jsSubmitText) {
        submitText.textContent = enhancedControl.dataset.jsSubmitText;
      }
    }

    picker.dataset.variantEnhanced = 'true';
  };

  const activateTree = (root) => {
    if (root.matches?.(pickerSelector)) activatePicker(root);
    root.querySelectorAll?.(pickerSelector).forEach(activatePicker);
  };

  document.addEventListener('product-info:loaded', (event) => {
    if (!(event.target instanceof Element) || !event.target.matches('product-info')) return;
    readyProductInfo.add(event.target);
    activateTree(event.target);
  });

  Promise.all([customElements.whenDefined('variant-selects'), customElements.whenDefined('product-info')]).then(() => {
    activateTree(document);

    new MutationObserver((records) => {
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (node.nodeType === Node.ELEMENT_NODE) activateTree(node);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  });
})();
